
document.addEventListener("DOMContentLoaded", function() {
  const material_buttons = document.querySelectorAll(".materials-button");
  const material_images = document.querySelectorAll(".materials-image-container img");

  material_buttons.forEach((material_button, index) => {
    material_button.addEventListener("click", function () {
      // すべてのボタンのactiveクラスを削除する
      material_buttons.forEach((btn) => {
        btn.classList.remove("active");
      });

      // すべての画像のactiveクラスを削除する
      material_images.forEach((img) => {
        img.classList.remove("active");
      });

      // クリックされたボタンにactiveクラスを追加する
      material_buttons[index].classList.add("active");

      // クリックされたボタンに対応する画像にactiveクラスを追加する
      material_images[index].classList.add("active");
  });
  });
});
